import { Outlet } from 'react-router-dom';
import Header from "./component/Header";
import Footer from "./component/Footer";


const Layout = () => {
    return (
        <>
            <Header />
            <main>
                <Outlet /> {/* This will render nested routes like /visa or /visa/s */}
            </main>
            <Footer />
        </>
    );
};

export default Layout;
